<template>
  <div class="align-center no-perm">
    <div class="no-perm-content">
        <div class="inline-block">
            <img class="layout-logo-img" src="../../../static/image/no-permission.png">
            <div class="inline-block">
                <h2>{{msg}}</h2>
                <h3><span>{{loginTime}}{{$t('home.back')}}...</span></h3>
                <Button  @click="$api.loginout()">
                    <Icon type="power" size="14"></Icon>
                    <span>{{$t('home.directBack')}}</span>
                </Button>
            </div>
        </div>
    </div>
  </div>
</template>
<style>
.no-perm{
    width: 100%;
    height: 100%;
    /* background-image: url(../../../static/image/no-permission.png);  */
}
.no-perm img{
    width: 400px;
    height: 300px;
    display: block;
}
.no-perm-content{
    padding-top: 100px;
    font-family: MicrosoftYaHei-Bold;
    color: rgba(29,30,40,0.80);
}
.no-perm-content h1{
    padding: 20px;
}
.no-perm-content button{
    margin-top: 20px;
}
</style>

<script>
export default {
  data () {
    return {
        loginTime:"10",
        msg: "对不起，您无权限操作系统，请重新登录！"
    }
  },
  mounted(){
      
  },
  methods:{
      init(){
        let self=this
        let myInterval=setInterval(function(){
            self.loginTime--;
            if(self.loginTime<1){
                self.$api.loginout()
                clearInterval(myInterval)
            }
        },1000)
      }
  }


}
</script>



// WEBPACK FOOTER //
// src/page/home/noPermission.vue